










































import { Component, Vue } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { LoginService } from "@/services/login.service.ts";
import { ElInput } from "element-ui/types/input";
import { ElForm } from "element-ui/types/form";
import { MESSAGE } from "@/models/Message";
import { Utils } from "@/services/utils";

import LoginBox from "@/views/components/LoginBox.vue";
import Header from "@/views/layout/Header.vue";
import { AuthenService } from '@/services/authen.service';

@Component({
  components: {
    LoginBox,
    Header
  }
})
export default class Login extends Vue {
  @Action("setToken", { namespace: "AuthStore" }) public setToken: any;
  @Getter("getToken", { namespace: "AuthStore" }) public token: any;

  /** 2021-08-05 sh #7329 add loginTypeKbn to store for Admin check [START] */
  @Action("setLoginTypeKbn", { namespace: "AuthStore" })
  public setLoginTypeKbn: any;
  /** 2021-08-05 sh #7329 add loginTypeKbn to store for Admin check [END] */

  public $refs!: {
    loginForm: ElForm;
    userInput: ElInput;
    pwdInput: ElInput;
  };

  public loading = false;
  public loginService: any = new LoginService();
  public utils = new Utils();
  public errorMsg: string = "";
  public authService: AuthenService = new AuthenService();

  constructor() {
    super();
  }

  created() {
    this.authService.clearAuth();
  }

  public async onSubmit(formData: any) {
    if (formData) {
      const response = await this.loginService.login(formData);
      if (response.result) {
        localStorage.setItem("token", response.result.token);
        localStorage.setItem("kyotenCd", response.result.kyotenCd);
        localStorage.setItem("loginTypeKbn", response.result.loginTypeKbn);
        this.setToken(response.result.token);
        /** 2021-08-05 sh #7329 add loginTypeKbn to store for Admin check [START] */
        this.setLoginTypeKbn(response.result.loginTypeKbn);
        /** 2021-08-05 sh #7329 add loginTypeKbn to store for Admin check [END] */
        this.$router.push("/");
      } else if (response.error) {
        if (response.error.rsltComment && response.status < 500) {
          this.errorMsg = response.error.rsltComment;
        } else {
          this.errorMsg = MESSAGE.SystemError;
        }
      }
    }
  }
}
